import React from 'react';
import { Course } from '../../../types/grades';
import { GradeScale } from '../../../types/universities';

interface CourseGradeSelectProps {
  course: Course;
  onChange: (updatedCourse: Course) => void;
  gradeScale: GradeScale[];
}

export function CourseGradeSelect({ 
  course, 
  onChange, 
  gradeScale 
}: CourseGradeSelectProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1.5">
        Grade
        {course.isSpecialGrade && (
          <span className="ml-2 text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
            Special
          </span>
        )}
      </label>
      <select
        value={course.grade || ''}
        onChange={(e) => onChange({ ...course, grade: e.target.value })}
        className="w-full px-3 py-2 border border-gray-300 rounded-md 
                   focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                   transition-colors duration-200"
      >
        <option value="">Select Grade</option>
        {gradeScale.map(grade => (
          <option key={grade.grade} value={grade.grade}>
            {grade.grade} {grade.minScore !== undefined && `(${grade.minScore}-${grade.maxScore}%)`}
          </option>
        ))}
      </select>
    </div>
  );
}